import { getM8PartnerURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError, WrongPasswordError } from 'utils/errors';
import { appendFormDataWithObjectValues, customFetch } from 'utils/http';

type Params = {
  password: string;
  newPassword: string;
};

export const updatePartnerPassword = async (params: Params): Promise<void> => {
  const fetchURL = getM8PartnerURL('updatePartnerPassword');

  const body = new FormData();

  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(fetchURL, { method: 'PUT', body });

  if (!response.ok) {
    if (response.status === 400) {
      throw new WrongPasswordError();
    }

    throw new HTTPResponseError(response);
  }
};
